export function getDate(blog) {
  const getDate = blog.created.split("T")[0].split("-");
  return getDate[2] + "-" + getDate[1] + "-" + getDate[0];
}
